import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Loader from "../../components/loader";
import { useNCallContext } from "../../context/ncall-context";
import { authoriseUser } from "../../service/auth";
import { showErrorToast } from "../../utils/toast";

const LoginAdmin = () => {
  const { state } = useNCallContext();
  const [email, setEmail] = useState("");
  const [password, setPassord] = useState("");

  const navigate = useNavigate();

  const authenticateUser = () => {
    const { data, error } = authoriseUser(email, password);

    if (!error) {
      localStorage.setItem("logged-in-as", "admin");
      navigate("/admin", { replace: true });
    } else {
      showErrorToast("User Dosen't Exists!");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("logged-in-as")) {
      if (localStorage.getItem("logged-in-as") === "admin") {
        navigate(`/admin`);
      } else if (localStorage.getItem("logged-in-as") === "client") {
        navigate(`/client`);
      }
    }
  }, []);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <div className=" bg-slate-100 h-screen ">
      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h1 className="mt-6 text-center text-3xl font-bold tracking-tight text-indigo-500">
            Admin Login
          </h1>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={authenticateUser}>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassord(e.target.value)}
                    required
                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
              </div>
              {/* <button
                onClick={() => navigate("/", { replace: true })}
                className=" text-indigo-500 font-bold underline"
              >
                Login As Client
              </button> */}

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span>Login</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default LoginAdmin;
